import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtVerify, SignJWT } from 'jose';


const SummaryItemEvent22To28 = () => {
	const [formData, setFormData] = useState({
		servernumber: "",
	});
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");

	const [flow, setFlow] = useState(null);
	const [lineUserID, setLineUserID] = useState(null);
	const [refCode, setRefCode] = useState(null);
	const [otp, setOtp] = useState(null);
	const [action, setAction] = useState(null);
	const [gameid, setGameID] = useState(null);

	const [data, setData] = useState({
    itemSummary: [],
    debtSummary: [],
    deductLog: [],
    helpSummary: []
  });

	const serverOptions = [
		{ value: 3, label: "Ginza" },
		{ value: 4, label: "Harajuku" },
	];

	// Decode token and set state
	useEffect(() => {
		const decodeToken = async () => {
			const urlParams = new URLSearchParams(window.location.search);
			const token = urlParams.get("token");

			//console.log("Token:", token);

			if (token) {
				try {
					const key = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");
					const { payload } = await jwtVerify(token, key);

					// Set your state values here
					setFlow(payload.flow);
					setLineUserID(payload.lineUserID);
					setRefCode(payload.refCode);
					setOtp(payload.otp);
					setAction(payload.action);
					setGameID(payload.gameid);

				} catch (error) {
					console.error("Invalid token:", error);
					setErrors({ apiError: "ข้อมูลไม่ถูกต้องกรุณาตรวจสอบ URL" });
				}
			} else {
				setErrors({ apiError: "ข้อมูลไม่ถูกต้องกรุณาตรวจสอบ URL" });
			}
		};

		decodeToken(); // Call the async function
	}, []); // Empty dependency array ensures this runs only once

	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
			...formData,
			[name]: type === "checkbox" ? checked : value,
		});
	};

	const validateForm = () => {
		const newErrors = {};
		if (!formData.servernumber) newErrors.servernumber = "กรุณาเลือก Server Game";
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setSuccessMessage("");
		if (!validateForm()) return;

		const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (!token) return

		try {
			setLoading(true);
			const headers = {
				"Accept-Language": "th",
				"Accept": "application/json;charset=UTF-8",
				"Content-Type": "application/json;charset=UTF-8",
				"api-key": "ss3+Nn9s%!$$DJ35bXISQYC!c+^P4x3Rk*2nWB3Q%$k29yUzLAthISeXa%d2LMvG",
				"login-access-token": token,
			};
			const secret = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");  
			const alg = 'HS256'
			const jwt = await new SignJWT({ ...formData, gameid, refCode, otp, lineUserID, action, flow })
				.setProtectedHeader({ alg })
				.setIssuedAt()
				.setExpirationTime('2h')
				.sign(secret);
			const response = await axios.post(
				"https://apis.ranworld-adventures.com/v1/account/summary/itemevents",
				{ token: jwt },
				{ headers }
			);
			//console.log(response.data);
			setData(response.data)
			// setSuccessMessage("ยืนยันข้อมูลไอดีเกมเรียบร้อยครับ");
			setFormData({
				servernumber: "",
			});
			setErrors({});
			if (response.data.itemSummary.length == 0) {
				setErrors({apiError: "ไม่พบข้อมูลไอเท็ม" });
			}
		} catch (error) {
			console.error("Error submitting registration:", error);
			setErrors({
				apiError: error.response?.data || "An unexpected error occurred.",
			});
		} finally {
			setLoading(false);
		}
	};

	const ErrorModalNew = ({ title, message, onClose }) => {
		return (
			<div className="modal-overlay">
				<div className="modal2">
					<h3>{title}</h3>
					<p>{message}</p>
					<button onClick={onClose}>ปิด</button>
				</div>
			</div>
		);
	};

	const renderTable = (title, columns, rows) => (
    <div style={{ marginBottom: '2rem', overflowX: 'auto', maxWidth: '100%' }}>
      <h3 style={{
        fontFamily: 'Prompt',
        fontSize: '18px',
        marginBottom: '10px',
        borderBottom: '2px solid #007bff',
        color: '#007bff'
      }}>{title}</h3>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontFamily: 'Prompt',
        minWidth: '600px'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#f0f0f0' }}>
            {columns.map((col, idx) => (
              <th key={idx} style={{
                padding: '10px',
                border: '1px solid #ccc',
                textAlign: 'left',
                fontSize: '14px',
                whiteSpace: 'nowrap'
              }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {columns.map((col, j) => (
                <td key={j} style={{
                  padding: '10px',
                  border: '1px solid #eee',
                  fontSize: '14px',
                  whiteSpace: 'nowrap'
                }}>
                  {typeof row[col.key] === "number"
                    ? row[col.key].toLocaleString("th-TH")
                    : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
	
	return (
    <div style={{ padding: "20px" }}>
      {/* ฟอร์มอยู่ตรงกลางสำหรับมือถือ */}
				<div style={{ maxWidth: "400px", margin: "auto" }}>

					{errors.apiError && (
						<ErrorModalNew title="ขออภัย" message={errors.apiError} onClose={() => setErrors({ apiError : null})}/>
					)}

					{successMessage && (
						<div
							style={{
								color: "green",
								marginBottom: "20px",
								padding: "10px",
								border: "1px solid green",
								borderRadius: "5px",
								backgroundColor: "#dfd",
								fontFamily: "Prompt"
							}}
						>
							{successMessage}
						</div>
					)}

				{/* Display Query Parameters */}
				<div
					style={{
						marginBottom: "20px",
						padding: "10px",
						border: "1px solid #ccc",
						borderRadius: "5px",
						backgroundColor: "#f9f9f9",
					}}
				>
					<ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
						{[
							{ title: "รหัสอ้างอิง", value: refCode },
							{ title: "ไอดี", value: gameid },
						].map(({ title, value }) => (
							<li
								key={title}
								style={{
									display: "flex",
									justifyContent: "space-between",
									padding: "5px 0",
								}}
							>
								<span style={{ fontSize: "14px", color: "#555", flex: 1 }}>{title}:</span>
								<span style={{ fontSize: "14px", color: "#555", flex: 1, textAlign: "right" }}>{value || "N/A"}</span>
							</li>
						))}
					</ul>
				</div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
						<label>
							Server Game:
							<select
								name="servernumber"
								value={formData.servernumber}
								onChange={handleInputChange}
								style={{
									display: "block",
									width: "100%",
									padding: "10px",
									marginTop: "5px",
									border: "1px solid #ccc",
									borderRadius: "5px",
									boxSizing: "border-box",
									fontFamily: "Prompt"
								}}
							>
								<option value="">เลือก Server</option>
								{serverOptions.map((question) => (
									<option key={question.value} value={question.value}>
										{question.label}
									</option>
								))}
							</select>
							{errors.servernumber && (
								<span style={{ color: "red", fontSize: "12px" }}>
									{errors.servernumber}
								</span>
							)}
						</label>
					</div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: loading ? "#ccc" : "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              fontSize: "16px",
              cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "Prompt"
            }}
          >
            {loading ? "กำลังตรวจสอบ..." : "ตรวจสอบข้อมูล"}
          </button>
        </form>
      </div>

      {/* ตารางขยายเต็มจอแบบ Responsive */}
      {data.itemSummary.length > 0 && (
        <div style={{ marginTop: "2rem" }}>
          {renderTable("📦 รายการไอเท็ม", [
            { key: "ChaName", label: "ชื่อตัวละคร" },
            { key: "ChaNum", label: "หมายเลขตัวละคร" },
            { key: "ItemSID", label: "รหัสไอเท็ม" },
            { key: "ชื่อไอเท็ม", label: "ชื่อไอเท็ม" },
            { key: "จำนวนครั้งที่กดซื้อ", label: "จำนวนที่กดซื้อ" },
            { key: "จำนวนชิ้นทั้งหมด", label: "จำนวนรวม" },
            { key: "จำนวนชิ้นที่ใช้ไปแล้ว", label: "ใช้แล้ว" },
            { key: "จำนวนชิ้นที่ยังไม่ได้ใช้", label: "ยังไม่ได้ใช้" },
            { key: "ราคา/ชิ้น", label: "ราคา/ชิ้น" }
          ], data.itemSummary)}

          {renderTable("💰 รายการหนี้", [
            { key: "ชื่อตัวละคร", label: "ชื่อตัวละคร" },
            { key: "รหัสไอเท็ม", label: "รหัสไอเท็ม" },
            { key: "ลดหนี้ได้", label: "ลดหนี้ได้" },
            { key: "หนี้คงเหลือ", label: "หนี้คงเหลือ" }
          ], data.debtSummary)}

          {renderTable("📝 ประวัติการหักเงิน/ลบไอเท็ม", [
            { key: "ActionOrder", label: "#" },
            { key: "ChaNum", label: "หมายเลขตัวละคร" },
            { key: "CharName", label: "ชื่อตัวละคร" },
            { key: "ItemSID", label: "รหัสไอเท็ม" },
            { key: "Step", label: "ขั้นตอน" },
            { key: "Detail", label: "รายละเอียด" }
          ], data.deductLog)}

          {renderTable("🧑‍🤝‍🧑 ผู้ช่วยเหลือ", [
            { key: "ผู้ช่วย", label: "ชื่อผู้ช่วย" },
            { key: "ช่วยเหลือ", label: "ช่วยใคร" },
            { key: "รหัสไอเท็ม", label: "รหัสไอเท็ม" },
            { key: "ประเภทการช่วย", label: "ประเภท" },
            { key: "รวมที่ช่วยไป", label: "จำนวนที่ช่วย (บาท)" }
          ], data.helpSummary)}
        </div>
      )}
    </div>
  );

};

export default SummaryItemEvent22To28;
